import { loadStripe } from '@stripe/stripe-js';

import { STRIPE_PK } from './config';

// Single Stripe.js promise for the app (loadStripe must be called once).
// STRIPE_PK comes from the existing environment keys.
export const stripePromise = STRIPE_PK ? loadStripe(STRIPE_PK) : null;

// Brand-tinted appearance for the Stripe Payment Element.
export const stripeAppearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#4f9d27',
    colorText: '#613f23',
    borderRadius: '10px',
    fontFamily: '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
};
